<template>
    <v-container v-if="plant">
        <h1>{{ $t('key.neophyteName') }}</h1>
        <v-row>
            <v-card-title>{{ plant.name }}</v-card-title>
        </v-row>
        <h1>{{ $t('key.mixUps') }}</h1>
        <v-row>
            <v-col>
                <v-chip v-if="plant.mixUps.length==0">
                    Keine Verwechslungsgefahr
                </v-chip>
                <v-chip v-for="(item, idx) in plant.mixUps" :key="idx"
                        @click="openSite(item)"
                        class='with_link'
                >
                    {{item}}
                    <v-icon>
                        mdi-open-in-new
                    </v-icon>
                </v-chip>
            </v-col>
        </v-row>
        <v-row>
            <v-col v-if="showImages">
                <ImageCarousel :refId="plant.uuid"></ImageCarousel>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <div class="markdown" v-html="compiledMarkdown"></div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import marked from 'marked'
    import ImageCarousel from '../../base/ImageCarousel'

    export default {
        name: 'PlantContext',
        props: {
            plant: Object,
            showImages: {
                type: Boolean,
                required: false,
                default: true
            },
        },
        components: {
            ImageCarousel
        },
        methods: {
            openSite(url) {
                /* comment out, will return
                if (url == undefined)
                    return
                if ('http' == url.slice(0, 3))
                    window.open(url, '_blank')
                else
                    window.open('http://' + url, '_blank')
                    */
                window.open('https://www.google.at/search?q=' + url, '_blank')
            }
        },
        computed: {
            compiledMarkdown() {
                return marked(this.plant.briefing)
            }
        }
    }
</script>

<style lang="scss">
    .markdown {
        // empty
    }

    .v-chip {
        margin-right: 5px;
    }

    .no_link {
        cursor: default !important;
    }
</style>
